import { ProductFeature } from '@/api/generated/api.enum';
import { useBillingState } from '@/composables/billing/useBillingState';
import { computed, type ComputedRef } from 'vue';

export function useSupportMeasureFeature(): {
  hasSupportMeasures: ComputedRef<boolean>;
} {
  const { hasFeature } = useBillingState();
  const hasSupportMeasures = computed<boolean>(() => hasFeature(ProductFeature.supportMeasures));
  return { hasSupportMeasures };
}
